/* tslint:disable:component-selector */
import {AfterViewInit, Component, OnDestroy, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NinjaCumulativeData, NinjaData } from '../../models/ninja-data.model';
import {Observable, Subject} from 'rxjs';
import { DataService } from '../data.service';
import { CountriesListComponent } from '../../shared/countries/countries-list/countries-list.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import {takeUntil} from "rxjs/operators";


@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements AfterViewInit, OnDestroy {

  cumulativeData$: Observable<NinjaCumulativeData> = this.dataService.getCumulativeData();
  sortedCountries$: Observable<NinjaData[]> = this.dataService.getSortedCountries();
  @ViewChild(CountriesListComponent) countriesListComponent!: CountriesListComponent;
  @ViewChild(MatSidenav) sidenav!: MatSidenav;
  collapseSidebar = false;
  private isDestroyed = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private observer: BreakpointObserver,
    private dataService: DataService,
  ) {
  }

  ngAfterViewInit(): void {
    this.observer.observe(['(max-width: 1118px)'])
      .pipe(
        takeUntil(this.isDestroyed)
      )
      .subscribe((res) => {
        if (res.matches) {
          this.collapseSidebar = true;
          this.sidenav.mode = 'over';
          this.sidenav.close();
        } else {
          this.collapseSidebar = false;
          this.sidenav.mode = 'side';
          this.sidenav.open();
        }
      });
  }

  getSearchQuery(event: any): void {
    const searchQuery = event.target.value;
    this.countriesListComponent.searchCountries(searchQuery);
  }

  ngOnDestroy(): void {
    this.isDestroyed.next();
    this.isDestroyed.complete();
  }

}
